<template>
  <country-components />
</template>

<script>
import Country from "@/components/Country";
export default {
  name: "Country",
  components: {
    "country-components": Country
  }
};
</script>

<style>
</style>
